import { useMutation } from "@tanstack/react-query";
import { api } from "../lib/api";

type NoteTitleFavoriteAction = "add" | "remove";

interface NoteTitleFavoritesParams {
  userId: string;
  sta3n: string;
  favorite: string;
  action: NoteTitleFavoriteAction;
}

interface NoteTitleFavoritesResponse {
  favorites?: string[];
}

const normalizeFavorites = (favorites: unknown): string[] => {
  if (!Array.isArray(favorites)) {
    return [];
  }

  return Array.from(
    new Set(
      favorites
        .map((value) => (typeof value === "string" ? value.trim() : ""))
        .filter(Boolean)
    )
  );
};

const ENDPOINT_BY_ACTION: Record<NoteTitleFavoriteAction, string> = {
  add: "/va/note-titles/favorites/add",
  remove: "/va/note-titles/favorites/remove",
};

export function useNoteTitleFavorites() {
  return useMutation({
    mutationFn: async ({ userId, sta3n, favorite, action }: NoteTitleFavoritesParams) => {
      const response = await api.post<NoteTitleFavoritesResponse>(ENDPOINT_BY_ACTION[action], {
        user_id: userId,
        sta3n,
        favorite,
      });

      return normalizeFavorites(response?.favorites);
    },
  });
}

export default useNoteTitleFavorites;
